import DashboardHomeView from '../../components/DashboardHomeView';

DashboardHomeScreen.propTypes = {};

function DashboardHomeScreen(props) {
  return (
    <div className="container-fluid px-0">
      <DashboardHomeView />
    </div>
  );
}

export default DashboardHomeScreen;
